import { useSearch, useRouter } from '@okapi/router-react';
import { useCallback } from 'react';

export const useModalParameter = (parameterName: string): [boolean, () => void] => {
  const [searchParams, setSearchParams] = useSearch();
  const router = useRouter();

  const removeParameter = useCallback(() => {
    const newParams = { ...searchParams };
    delete newParams[parameterName];
    if (!Object.keys(newParams).length) {
      router.navigate(`${router.getPath()}`, true);
    } else {
      setSearchParams(newParams);
    }
  }, [parameterName, searchParams, setSearchParams]);

  return [!!searchParams[parameterName], removeParameter];
};
